import React, { useEffect, useState } from "react";
import { AnimatedButton } from "../ui/AnimatedButton";
import { KeyboardArrowUp } from "@mui/icons-material";
import { useTheme } from "@mui/material";

const ScrollToTop: React.FC = () => {
  const theme = useTheme();
  const [visible, setVisible] = useState<boolean>(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <AnimatedButton
      onClick={scrollToTop}
      style={{
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none", 
      }}
      aria-label="Scroll to top"
      sx={{
        position: "fixed",
        bottom: {xs: theme.spacing(10), lg: theme.spacing(5)},
        right: {xs: theme.spacing(2), lg: theme.spacing(6)},
        transition: "filter 0.4s ease, opacity 0.4s ease",
        height: "2.8rem",
        width: "3rem",
        minWidth: 0,
        zIndex: 1000,
        "&:hover": {
          filter:
            "drop-shadow(rgba(0, 0, 0, 0) 0px -1px 1px 0px inset, rgba(0, 0, 0, 0.67) 0px 5px 10px 0px)",
        },
      }}
    >
      <KeyboardArrowUp />
    </AnimatedButton>
  );
};

export default ScrollToTop;
